import { uniqueId } from 'lodash';
import JWT from 'jsonwebtoken';
import request from '../../helpers/request';
import { showNotification } from '../Notification/notificationActions';
import { setCookie } from '../../helpers/cookies';

const loginRequest = () => {
    return { type: 'LOGIN_REQUEST' };
};

const loginSuccess = (token, email, nickname, username, password) => {
    const JWTDecode = JWT.decode(token);

    const expireDay =
        (new Date(JWTDecode.exp * 1000) - new Date()) / (1000 * 3600 * 24);

    const data = {
        token,
        id: JWTDecode.data.user.id,
        email,
        nickname,
        isLogin: true,
        expireDay,
        username,
        password
    };

    setCookie('auth', data, expireDay);
    return { type: 'LOGIN_SUCCESS', data };
};

const loginFailure = error => {
    return {
        type: 'LOGIN_FAILURE',
        error
    };
};

const login = data => async dispatch => {
    try {
        dispatch(loginRequest());

        const response = await request({
            method: 'post',
            url: '/jwt-auth/v1/token',
            data
        });

        dispatch(
            loginSuccess(
                response.token,
                response.user_email,
                response.user_nicename,
                data.username,
                data.password
            )
        );
    } catch (error) {
        let errorText = '';

        if (error.status === 403) {
            errorText = 'نام کاربری یا رمز عبور اشتباه است';
        } else {
            errorText = '';
        }

        dispatch(
            showNotification({
                id: uniqueId('error-'),
                type: 'error',
                text: errorText
            })
        );

        dispatch(loginFailure(error));
    }
};

export { loginRequest, loginSuccess, loginFailure, login };
